import gql from 'graphql-tag';

import { ImageFragments } from './fragments/ImageType';
import { PostFragments, PostCardFragment } from './fragments/PostType';
import { UserFragments } from './fragments/UserType';
import { CatchFragments } from './fragments/CatchType';

export const getPost = gql`
  query GetPost($externalId: String) {
    entry: post(externalId: $externalId) {
      ...PostId
      ...PostCardFields
      ...PostProductUnits
      ...DisplayProductUnits
      images(first: 20, width: 960) {
        totalCount
        edges {
          node {
            ...ImageFields
          }
        }
      }
      user {
        nickname
      }
    }
  }
  ${PostFragments.id}
  ${PostCardFragment}
  ${PostFragments.productUnits}
  ${PostFragments.displayProductUnits}
  ${ImageFragments.imageFields}
`;

export const getPostMetadata = gql`
  query GetPostMetadata($externalId: String) {
    entry: post(externalId: $externalId) {
      ...PostId
      externalId
      catch {
        ...CatchId
      }
      text {
        text
      }
      images(first: 1, width: 960) {
        edges {
          node {
            ...ImageFields
          }
        }
      }
      ...PostVideoFields
      user {
        nickname
      }
    }
  }
  ${PostFragments.id}
  ${PostFragments.videoFields}
  ${CatchFragments.id}
  ${ImageFragments.imageFields}
`;

export const getPostExternalId = gql`
  query GetPostExternalId($id: Int) {
    entry: post(id: $id) {
      ...PostId
    }
  }
  ${PostFragments.id}
`;

export const getPostByExternalId = gql`
  query GetPostByExternalId($externalId: String) {
    entry: post(externalId: $externalId) {
      externalId
    }
  }
`;

export const getPostComments = gql`
  query GetPostComments($externalId: String, $first: Int, $after: String) {
    entry: post(externalId: $externalId) {
      ...PostId
      comments(first: $first, after: $after) {
        pageInfo {
          endCursor
          startCursor
          hasNextPage
        }
        totalCount
        edges {
          cursor
          node {
            ...PostId
            createdAt
            user {
              ...UserId
              nickname
              ...UserAvatar
            }
            text {
              text
            }
            likedByCurrentUser
            likesCount
            comments(first: 20) {
              totalCount
              edges {
                node {
                  ...PostId
                  createdAt
                  user {
                    ...UserId
                    nickname
                    ...UserAvatar
                  }
                  text {
                    text
                  }
                  likedByCurrentUser
                  likesCount
                }
              }
            }
          }
        }
      }
    }
  }
  ${UserFragments.avatar}
  ${PostFragments.id}
  ${UserFragments.id}
`;

export const getPostLikers = gql`
  query GetPostLikers($externalId: String) {
    post(externalId: $externalId) {
      ...PostId
      likers(last: 12) {
        edges {
          node {
            ...UserId
            ... on User {
              firstName
              lastName
              nickname
            }
            ...UserAvatar
          }
        }
      }
    }
  }
  ${PostFragments.id}
  ${UserFragments.avatar}
  ${UserFragments.id}
`;

export const getPostLikes = gql`
  query GetPostLikes($externalId: String) {
    post(externalId: $externalId) {
      ...PostId
      likedByCurrentUser
      likesCount
    }
  }
  ${PostFragments.id}
`;
